import type { CSSObject } from '@emotion/react'
import { Color, Typography } from '@opallabs/gem'

export const categoryHeader: CSSObject = {
  backgroundColor: Color.light.Surface.N000,
  color: Color.light.Text.Default,
  ...Typography.T500,
  alignItems: 'center',
  display: 'flex',
  blockSize: 37,
  justifyContent: 'center',
  inlineSize: '100%',
}

export const day: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  padding: '0 8px',
  whiteSpace: 'nowrap',
  '&:first-of-type': {
    paddingLeft: 12,
  },
  '&:last-of-type': {
    paddingRight: 12,
  },
  '& > *': {
    flexGrow: 1,
    textAlign: 'center',
  },
}
